/* eslint-disable react-hooks/exhaustive-deps */

import { useContext, useEffect, useMemo, useRef } from 'react';
import { ClickAwayContext } from './ClickAwayContext';
import { ClickAwayContextValue } from './types';

/**
 * Be aware of WHEN you call register and deregister function !!
 * - register - should be called after overlay/dropdown menu/dialog/tooltip is opened and NOT when component is mount
 * - deregister - should be called after overlay/dropdown menu/dialog/tooltip is closed OR component will unmount
 */
export const useClickAway = () => {
    const registered = useRef(false);
    const contextValue = useContext(ClickAwayContext);

    const cleanup = () => {
        if (registered.current) {
            registered.current = false;
            contextValue.deregisterClickAway();
        }
    };

    useEffect(() => cleanup, []);

    return useMemo(
        (): ClickAwayContextValue => ({
            registerClickAway: (options) => {
                if (!registered.current) {
                    registered.current = true;
                    contextValue.registerClickAway(options);
                }
            },
            deregisterClickAway: () => {
                if (registered.current) {
                    registered.current = false;
                    contextValue.deregisterClickAway();
                }
            },
        }),
        [contextValue]
    );
};
